import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { SearchStringFilter } from './SearchStringFilter';
import { useGetTeams } from './useGetTeams/useGetTeams';
export const projectTeamMembersFilterLabel = () => t({ message: 'Members (teams)', comment: 'Insights filter: Members (teams)' });
export const ProjectTeamMembersFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetTeams();
    const disabled = Boolean(loading || error);
    return (<SearchStringFilter name="metadataProjectMembersTeamIds" items={data} label={projectTeamMembersFilterLabel()} loading={disabled}/>);
});
